module.exports = {
      id: "graph-usage",
      viewBox: "0 0 30 20",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#graph-usage",
      toString: function () {
        return this.url;
      }
    }